import HttpTransport from '@/bundles/Http/transport/HttpTransport';
import HttpClient from '@/bundles/Http/transport/HttpClient';
import { requestInterceptor } from '@/bundles/Http/interceptors/requestInterceptor';
import { responseErrorInterceptor } from '@/bundles/Http/interceptors/responseErrorInterceptor';

function httpFactory (baseURL: string) {
  const client = new HttpClient(
    { baseURL },
    requestInterceptor,
    responseErrorInterceptor,
  );

  return new HttpTransport(client);
}

const http = httpFactory(process.env.VUE_APP_API_URL);

export {
  http,
};
